/* Copyright 2013 - 2022 Waiterio LLC */
const colorSecondary = '#f25f5c'

export default colorSecondary
